import React, { useState } from 'react';
import './DownloadIndentDocuments.css';
import axios from '../../../Axios';
import {Urls} from '../../../Urls';
import { toast } from 'react-toastify';

export default function DownloadIndentDocuments() {
    const today = new Date().toISOString().split('T')[0];

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [maxDate, setMaxDate] = useState(today);
    const [indentType, setIndentType] = useState('My Indents');
    const [documentTypes, setDocumentTypes] = useState([]);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const formatDate = (dateStr) => {
        // yyyy-mm-dd → dd-mm-yyyy
        const [yyyy, mm, dd] = dateStr.split('-');
        return `${dd}-${mm}-${yyyy}`;
    };

    const handleStartDateChange = (e) => {
        const val = e.target.value;
        setStartDate(val);

        const d = new Date(val);
        d.setMonth(d.getMonth() + 1);
        const oneMonthLater = d.toISOString().split('T')[0];

        const calculatedMax = oneMonthLater > today ? today : oneMonthLater;
        setMaxDate(calculatedMax);

        if (endDate && endDate > calculatedMax) {
            setEndDate('');
        }
    };

    const toggleDocType = (doc) => {
        setDocumentTypes((prev) =>
            prev.includes(doc)
                ? prev.filter((d) => d !== doc)
                : [...prev, doc]
        );
    };

    const isFormValid =
        startDate &&
        endDate &&
        indentType &&
        documentTypes.length > 0;

   const handleSubmit = async () => {
    if (!isFormValid || loading) return;

    const payload = {
        from_date: formatDate(startDate),
        to_date: formatDate(endDate),
        view:
            indentType === 'Company Indents'
                ? 'company_view'
                : 'user_view',
        download_types: documentTypes.map(d => d.toUpperCase()),
    };

    try {
        setLoading(true);

        const response = await axios.post(
            `${Urls.indentRootUrl}indent_document_export`,
            payload
        );

        const data = response.data;

        if (data?.status === 'completed' && data?.download_url) {
            window.location.href = data.download_url;
        } else {
            toast.info(data.error);
        }
    } catch (error) {
        console.error('Download failed:', error);
    } finally {
        setLoading(false);
    }
};

    const displayText =
        documentTypes.length === 0 ? 'Select' : documentTypes.join(', ');

    return (
        <div className="filters-container">
            <div className="filters-row">
                <div className="filter">
                    <label>From</label>
                    <input
                        type="date"
                        value={startDate}
                        onChange={handleStartDateChange}
                        max={today}
                        required
                    />
                </div>

                <div className="filter">
                    <label>To</label>
                    <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        min={startDate}
                        max={maxDate}
                        disabled={!startDate}
                        required
                    />
                </div>

                <div className="filter">
                    <label>User Type</label>
                    <select
                        value={indentType}
                        onChange={(e) => setIndentType(e.target.value)}
                        required
                    >
                        <option value="My Indents">My Indents</option>
                        <option value="Company Indents">
                            Company Indents
                        </option>
                    </select>
                </div>

                <div className="filter">
                    <label>Document Type</label>
                    <div className="multiselect">
                        <button
                            type="button"
                            className="multiselect-btn"
                            onClick={() => setOpen(!open)}
                        >
                            <span>{displayText}</span>
                            <span className="caret">▾</span>
                        </button>

                        {open && (
                            <div className="multiselect-overlay">
                                {['LR', 'POD', 'Invoice'].map((doc) => (
                                    <label
                                        key={doc}
                                        className="checkbox-row"
                                    >
                                        <input
                                            type="checkbox"
                                            checked={documentTypes.includes(
                                                doc
                                            )}
                                            onChange={() =>
                                                toggleDocType(doc)
                                            }
                                        />
                                        <span>{doc}</span>
                                    </label>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <div className="filter submit-filter">
                    <button
                        className="submit-btn"
                        disabled={!isFormValid || loading}
                        onClick={handleSubmit}
                    >
                        {loading ? 'Downloading…' : 'Download'}
                    </button>
                </div>
            </div>
        </div>
    );
}
